import { createFileRoute, Link, Outlet, useLocation, useNavigate } from '@tanstack/react-router'

import styles from './app-layout.module.scss'
import { currencyFormat } from '@/utils/currency-format'
import { useAtom } from 'jotai'
import { userAtom } from '@/store/atoms/user.atom'
import { cardsServiceInstance } from '@/services/cards.service'
import { userServiceInstance } from '@/services/user.service'
import { useEffect } from 'react'
import { useConfigContext } from '@/contexts/config-context'
import { CACHE_KEYS } from '@/common/constants'
import { NotificationContextProvider } from '@/contexts/notification-context-provider'

export const Route = createFileRoute('/desktop/__app')({
  component: RouteComponent,
  loader: async () => {
    const [mePendingCards, amount] = await Promise.all([
      cardsServiceInstance.mePending(),
      userServiceInstance.wallet(),
    ])

    return {
      mePendingCards,
      amount
    }
  },
  shouldReload: true,
})

function RouteComponent() {
  const navigator = useNavigate()
  const [currentUser, setUser] = useAtom(userAtom)
  const { mePendingCards, amount } = Route.useLoaderData()
  const loc = useLocation()
  const { audioIsEnabled, changeAudioStatus } = useConfigContext()
  const isGamePage = loc.pathname === "/desktop/game"

  useEffect(() => {
    if (!currentUser) return
    setUser({
      ...currentUser,
      wallet: {
        amount
      }
    })
  }, [amount])

  const onQuit = () => {
    localStorage.removeItem(CACHE_KEYS.TOKEN)
    navigator({ to: '/' })
    setUser(undefined)
  }

  return (
    <NotificationContextProvider>
    <div className={styles.container}>
      <header>
        <div className={styles.navigation}>
          <img
            src="/assets/logo_header.png"
          />
          <nav>
            <Link to="/desktop/home">Início</Link>
            <Link to="/desktop/my-cards">Minhas cartelas</Link>
            <Link to="/desktop/policies">Políticas de uso</Link>
            <Link to="/desktop/how-to-play">Extração</Link>
            <a href={import.meta.env.VITE_LINK_URL} target="_blank" rel="noreferrer">Fale conosco</a>
            <button onClick={onQuit}>Sair</button>
          </nav>
        </div>

        <div className={styles.informations}>
          {
            isGamePage && (
              <>
                {/* <button onClick={handleOpenModalConfigTimingAnimation}>
                  <img
                    src="/assets/config.png"
                  />
                </button> */}
                <button
                  onClick={changeAudioStatus}

                >
                  {
                    audioIsEnabled ? (
                      <img
                        src="/assets/sound.png"
                      />

                    ) : (
                      <img
                        src="/assets/audio_off.png"
                      />
                    )
                  }
                </button>
              </>
            )
          }
          <div className={styles.amount}>
            <img
              src="/assets/coin.svg"
              className={styles.coin_img}
            />
            <span>{currencyFormat(currentUser?.wallet?.amount || 0)}</span>
          </div>
          <div className={styles.coin}>
            <img
              src="/assets/signboard.svg"
            />
            <span>{mePendingCards}</span>
          </div>
          {
            currentUser && currentUser?.wallet?.amount > 0 && (
              <button
                onClick={() => navigator({ to: '/desktop/withdraw' })}
              >
                <img
                  src="/assets/header_desk_btn.png"
                />
              </button>
            )
          }
        </div>
      </header>
      <div>
        <Outlet />
      </div>
    </div>
    </NotificationContextProvider>
  )
}
